import React from 'react';

interface FullscreenWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const FullscreenWrapper: React.FC<FullscreenWrapperProps> = ({ children, className }) => {
  return (
    <div className={className} style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
      position: 'absolute',
      top: 0,
      left: 0,
    }} data-testid="fullscreen-wrapper">
      {children}
    </div>
  );
};

export default FullscreenWrapper;